import { default as Box } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(({ theme }) => ({
  borderTop: '1px dashed lightgrey',
  paddingTop: 12,
  marginLeft: -18,
  marginRight: -18,
  [theme.breakpoints.up('sm')]: {
    marginLeft: -32,
    marginRight: -32
  }
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  marginLeft: 18,
  marginRight: 18,
  [theme.breakpoints.up('sm')]: {
    marginLeft: 32,
    marginRight: 32
  }
}));

export const InfoTextWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  paddingTop: 16,
  paddingBottom: 16,
  '& svg': {
    width: 18,
    height: 18,
    marginRight: 4,
    color: theme.palette.text.disabled
  },
  '& p': {
    whiteSpace: 'normal',
    textAlign: 'left',
    fontSize: 13,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  }
}));
